import React from 'react';
import { ICellRendererParams } from '@ag-grid-community/core';
import { StyledCellWrapper } from '@urc-ui/components/styles';
import { DateText } from '@urc-ui/components/date-text';
import { SUBSCRIPTION_STATUS } from '@urc-ui/utils/types';

export function NextRunCellRenderer(props: ICellRendererParams) {
  let nextScheduleTime = null;

  // Next run should be visible only for active subscriptions
  if (props.value?.status === SUBSCRIPTION_STATUS.ACTIVE) {
    nextScheduleTime = props.value?.nextScheduleTime;
  }

  return (
    <StyledCellWrapper>
      <DateText timestamp={nextScheduleTime} />
    </StyledCellWrapper>
  );
}
